.card {
  background-color: light-dark(var(--mantine-color-body), var(--mantine-color-primaryDark-8));
  transition: background-color 0.2s ease;
  border: 2px solid transparent;
}

.card:hover {
  background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-primaryDark-7));
}

.cardBorder {
  border: 2px solid var(--mantine-color-primaryDark-8);
}